import CardSlot from '@/pages/intelligence/components/CardSlot';
import React from 'react';
import { Col, Justify, Pagination, Row } from 'tea-component';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import './index.scss';
import GameImage from '@/pages/home/components/GameImage';
import classNames from 'classnames';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import { history } from 'umi';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import Search from './Search';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getGamesGenresTag } from '../../../../utils';

const GamesContext = (props: any) => {
  const {
    gameType,
    wholeTotal = 0,
    pageTotal = 0,
    gameDetail = [],
    searchGame,
    // receiveGameType,
    searchValue,
    setSearchValues,
    loading,
    onPagingChange,
    title,
  } = props;

  // console.log('GamesContext', props);
  return (
    <div className="owned-card-item">
      <Justify
        left={
          <div className="games-flex">
            <span className="games-num">{wholeTotal}</span>
            <span className="games-title">{title}</span>
          </div>
        }
        right={
          <Search
            gameType={gameType}
            searchGame={searchGame}
            searchValue={searchValue}
            setSearchValues={setSearchValues}
          />
        }
      />
      <div className="games-desc">{gameDetail?.metric_date}</div>
      <Row>
        {loading ? (
          <CardStats
            cardStatus={{
              isLoading: loading,
            }}
            height={520}
          />
        ) : (
          <>
            {gameDetail?.games?.map((e: any, i: any) => (
              <Col span={8} key={i}>
                <ItemBox data={e} type={gameType} />
              </Col>
            ))}
          </>
        )}
      </Row>
      <Pagination
        className="games-pagination"
        recordCount={pageTotal}
        stateText={`${gameDetail?.total} items in total`}
        pageSizeOptions={[15, 30, 45]}
        onPagingChange={(e) => {
          if (onPagingChange instanceof Function) {
            onPagingChange(e, gameType);
          }
        }}
        // pageSize={pageSize}
        // pageIndex={pageIndex}
        // recordCount={tableTotal}
        // stateTextVisible={true}
        // pageSizeVisible={tableTotal > pageSizeOptions[0]}
        // pageIndexVisible={tableTotal > pageSizeOptions[0]}
        // jumpVisible={tableTotal > pageSizeOptions[0]}
        // endJumpVisible={tableTotal > pageSizeOptions[0]}
      />
    </div>
  );
};

export default GamesContext;

const ItemBox = (porps: any) => {
  const { type, data } = porps;

  const getGamesMetrics = (item: any) => {
    const _tags = getGamesGenresTag(item);

    return {
      tags: _tags,
      // tagsTip: _tags.join(', ')
    };
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, type));
  };

  return (
    <CardSlot className="card-item">
      <ARightClickToJump
        href={getDetailGameOverviewPath(data.id, type)} /* style={{ display: 'inline' }}*/
      >
        <div
          className="games-item"
          onClick={() => {
            onClickGame(data.id);
          }}
        >
          <div className="games-item-left">
            <GameImage
              entityType={type}
              src={data?.cover}
              className={classNames({
                // mobile
                'message-img-one': type === 'mobile',
                // pc
                'message-img-two': type === 'pc',
                // console
                'message-img-three': type === 'console',
              })}
            />
            {/* <GameImage
            entityType={type}
            className={
              type == 'pc'
                ? 'dbi-firstRow-imgtwo'
                : type == 'console'
                  ? 'dbi-firstRow-imgthere'
                  : 'dbi-firstRow-imgone'
            }
            src={data?.cover}
          /> */}
            <div className="message-text">
              <div className="text-title">{data.name}</div>
              <div className="text-tip">
                {/* {getGamesMetrics(data)?.tagsTip ? ( */}
                <>
                  {/* <Bubble arrowPointAtCenter placement="top-end" content={getGamesMetrics(data)?.tagsTip}> */}
                  {getGamesMetrics(data)?.tags?.map((e: any, i: any) => (
                    <span className="tip-item" key={i}>
                      {e}
                    </span>
                  ))}
                  {/* </Bubble> */}
                </>
                {/* ) : null} */}
              </div>
            </div>
          </div>
          <div className="games-item-right">
            <div className="message-text">
              {type === 'mobile' ? (
                // appnnie
                <img className="text-img" src={getDataSourceIcon('sensortower')} />
              ) : null}
              {data.is_mscience === '1' ? (
                <img className="text-img" src={getDataSourceIcon('mscience')} />
              ) : null}
              {data.is_npd === '1' ? (
                <img className="text-img" src={getDataSourceIcon('npd')} />
              ) : null}
              <span className="text-tip">{'Revenue'}</span>
            </div>
            <div className="text-num">{data.revenue ? mathFormat(data.revenue) : '-'}</div>
          </div>
        </div>
      </ARightClickToJump>
    </CardSlot>
  );
};
